import { render, staticRenderFns } from "./Menitionable.vue?vue&type=template&id=2568b08c&"
import script from "./Menitionable.vue?vue&type=script&lang=js&"
export * from "./Menitionable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports